import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import * as Yup from "yup";

export default function SekcjaKontakt() {
  const honeypotRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      surname: "",
      phone: "",
      email: "",
      event_type: "",
      source: "",
      date: "",
      location: "",
      details: "",
      bot_field: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Imię jest wymagane"),
      surname: Yup.string().required("Nazwisko jest wymagane"),
      phone: Yup.string().required("Telefon jest wymagany"),
      email: Yup.string().email("Nieprawidłowy e-mail").required("Email jest wymagany"),
      event_type: Yup.string().required("Wybierz rodzaj imprezy"),
      source: Yup.string().required("Wybierz źródło"),
      date: Yup.string().required("Wybierz datę"),
      location: Yup.string().required("Wpisz lokalizację"),
      details: Yup.string().required("Napisz wiadomość"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.bot_field) return;
      setLoading(true);
      try {
        const response = await fetch("/send.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        });
        const result = await response.text();
        if (result === "OK") {
          toast.success("Dziękuję. Odezwę się niedługo.");
          resetForm();
        } else {
          toast.error("Błąd. Spróbuj ponownie.");
        }
      } catch (err) {
        toast.error("Błąd połączenia z serwerem.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <section id="kontakt" className="py-14 sm:py-24 bg-gray-100 text-black">
      <div className="max-w-2xl sm:max-w-3xl mx-auto px-2 xs:px-4">
        <h2 className="text-3xl xs:text-4xl md:text-5xl font-bold mb-6 sm:mb-8 text-center">
          Formularz kontaktowy
        </h2>
        <p className="text-gray-600 mb-6 sm:mb-10 text-center text-base sm:text-lg">
          Daj mi znać, czego potrzebujesz. Odezwę się jak najszybciej!
        </p>

        <form onSubmit={formik.handleSubmit} className="space-y-4 sm:space-y-6 bg-white/90 rounded-xl shadow-2xl shadow-orange-200/40 border border-orange-100 p-4 xs:p-6 sm:p-8 md:p-12" style={{boxShadow:'0 8px 32px 0 #ff730040, 0 2px 8px 0 #00000010'}} noValidate>
          <input
            type="text"
            name="bot_field"
            ref={honeypotRef}
            style={{ display: "none" }}
            tabIndex="-1"
            autoComplete="off"
            aria-hidden="true"
          />

          <div className="grid grid-cols-1 xs:grid-cols-2 gap-3 sm:gap-4">
            <input
              name="name"
              type="text"
              placeholder="Imię"
              onChange={formik.handleChange}
              value={formik.values.name}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
              required
            />
            <input
              name="surname"
              type="text"
              placeholder="Nazwisko"
              onChange={formik.handleChange}
              value={formik.values.surname}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
              required
            />
            <input
              name="phone"
              type="tel"
              placeholder="Telefon"
              onChange={formik.handleChange}
              value={formik.values.phone}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
              required
            />
            <input
              name="email"
              type="email"
              placeholder="E-mail"
              onChange={formik.handleChange}
              value={formik.values.email}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
              required
            />
            <select
              name="event_type"
              onChange={formik.handleChange}
              value={formik.values.event_type}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow appearance-none"
              required
            >
              <option value="">Rodzaj imprezy</option>
              <option>Wesele</option>
              <option>Event firmowy</option>
              <option>Urodziny</option>
              <option>Inne</option>
            </select>
            <select
              name="source"
              onChange={formik.handleChange}
              value={formik.values.source}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow appearance-none"
              required
            >
              <option value="">Jak do mnie trafiłeś/trafiłaś?</option>
              <option>Google</option>
              <option>Facebook / Instagram</option>
              <option>Z polecenia</option>
              <option>Inne</option>
            </select>
            <input
              name="date"
              type="date"
              onChange={formik.handleChange}
              value={formik.values.date}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow placeholder:text-gray-400"
              required
              placeholder="Data wydarzenia"
              onFocus={e => e.target.type='date'}
              onBlur={e => { if (!e.target.value) e.target.type='text'; }}
            />
            <input
              name="location"
              type="text"
              placeholder="Lokalizacja"
              onChange={formik.handleChange}
              value={formik.values.location}
              className="h-12 w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
              required
            />
          </div>

          <textarea
            name="details"
            placeholder="Opisz wydarzenie"
            rows={5}
            onChange={formik.handleChange}
            value={formik.values.details}
            className="w-full p-3 rounded-md border border-gray-300 bg-white shadow-md focus:shadow-orange-200/60 transition-shadow"
            required
          />

          <div className="pt-4 text-center">
            <button
              type="submit"
              disabled={loading}
              className="inline-block bg-black text-white px-8 py-3 text-base font-bold tracking-wide rounded-md hover:bg-orange-500 transition"
            >
              {loading ? "Wysyłanie..." : "Wyślij wiadomość"}
            </button>
          </div>
        </form>

        {/* Dane kontaktowe pod spodem */}
        <div className="mt-16 text-center text-gray-700 space-y-2">
          <p>📧 biuro@djkusy.pl</p>
          <p>📞 +48 690 442 187</p>
          <p>📍 Rzeszów, woj. podkarpackie</p>
        </div>
      </div>
    </section>
  );
}